module.exports = __webpack_public_path__ + "saravana-fdffc8c2a6fa09d1791ca03b1e989ae1.webp";